import { useTranslation } from "./i18n";

export default function AutosaveStatus({
  name,
  saving,
  dirty,
  error,
  retry,
  readOnly,
  hasSaved,
  tourTarget,
}: {
  name: string;
  saving: boolean;
  dirty: boolean;
  error: string;
  retry: () => void;
  readOnly?: boolean;
  hasSaved: boolean;
  tourTarget?: string;
}) {
  const { t } = useTranslation("automaticSave");
  return (
    <div className="record-autosave-error" data-tour={tourTarget}>
      <span className="record-autosave-status" role="status" aria-label={t("status", { name })}>
        {t(error ? "failed" : saving ? "saving" : dirty ? "incomplete" : hasSaved ? "saved" : "ready")}
      </span>
      {error && (
        <>
          <p className="form-error" role="alert" aria-label={t("error", { name })}>
            {error === "save-failed" ? t("failed") : error} {t("retained")}
          </p>
          <button type="button" disabled={readOnly || saving} onClick={retry}>
            {t("retry")}
          </button>
        </>
      )}
    </div>
  );
}
